var PresenterUtil, SupportDefaultStatusAndNotesPresentation, SupportUtilsHelper;

SupportDefaultStatusAndNotesPresentation = require('./default_messages');

SupportUtilsHelper = require('../helpers/utils');

PresenterUtil = (function() {
  function PresenterUtil() {}

  PresenterUtil.prototype.DELIMITER = "$$";

  PresenterUtil.prototype.STATUS = "status";

  PresenterUtil.prototype.NOTES = "notes";


  /*
  it is a strong assumption in the below logic that the keys in the key string would be
  unique. And the same key would not be repeating in the lookup hierarchy.
   */

  PresenterUtil.prototype.lookup = function(source, key_string, attribute) {
    var check_value, defaultLookup, hierarchy, i, keys, len, lookup_obj, obj, value;
    if ((attribute != null) && (source != null) && (key_string != null)) {
      defaultLookup = SupportDefaultStatusAndNotesPresentation;
      lookup_obj = $.extend(true, defaultLookup, source);
      value = lookup_obj[attribute];
      keys = key_string.split(PresenterUtil.prototype.DELIMITER);
      hierarchy = [lookup_obj];
      hierarchy = PresenterUtil.prototype.recursiveLookup(keys, hierarchy);
      for (i = 0, len = hierarchy.length; i < len; i++) {
        obj = hierarchy[i];
        check_value = obj[attribute];
        if (check_value != null) {
          value = obj[attribute];
        }
      }
    }
    return value;
  };


  /*
  Aim to find the deepest possible successful check. If available, pick it up
   */

  PresenterUtil.prototype.recursiveLookup = function(keys, matched_hierarchy) {
    var best_matched_hierarchy, child_object, further_lookups, i, idx, key, len, lookup_object, matched_hierarchySoFar, new_keys;
    if (!!matched_hierarchy) {
      best_matched_hierarchy = matched_hierarchy;
      if (!!keys && keys.length > 0) {
        lookup_object = matched_hierarchy[matched_hierarchy.length - 1];
        idx = -1;
        for (i = 0, len = keys.length; i < len; i++) {
          key = keys[i];
          idx = idx + 1;
          if (!!key) {
            child_object = lookup_object[key];
            if (!!child_object) {
              matched_hierarchySoFar = $.map(matched_hierarchy, function(m) {
                return m;
              });
              matched_hierarchySoFar.push(child_object);
              new_keys = $.map(keys, function(k) {
                return k;
              });
              new_keys.splice(idx, 1);
              further_lookups = PresenterUtil.prototype.recursiveLookup(new_keys, matched_hierarchySoFar);
              if (further_lookups.length > best_matched_hierarchy.length) {
                best_matched_hierarchy = further_lookups;
              }
            }
          }
        }
      }
      return best_matched_hierarchy;
    }
  };

  PresenterUtil.prototype.isShipmentAvailable = function(order) {
    var voucher;
    voucher = PresenterUtil.prototype.getFirstVoucher(order);
    if (voucher != null) {
      return (voucher.shipments != null) && voucher.shipments.length > 0;
    }
  };

  PresenterUtil.prototype.isReturnable = function(order) {
    if ((order != null ? order.isReturnable : void 0) != null) {
      return evaluate(order.isReturnable);
    } else {
      return false;
    }
  };

  PresenterUtil.prototype.getFirstVoucher = function(order) {
    var groupons;
    if (order != null) {
      groupons = order.groupons;
      if (groupons != null) {
        return groupons[0];
      }
    }
  };

  PresenterUtil.prototype.isRedeemed = function(order) {
    var voucher;
    voucher = PresenterUtil.prototype.getFirstVoucher(order);
    if (voucher != null) {
      return voucher.isMerchantRedeemed || voucher.isCustomerRedeemed;
    }
  };

  PresenterUtil.prototype.concatenateLookupKeys = function(keys) {
    var key;
    return ((function() {
      var i, len, results;
      results = [];
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        results.push(key.toLowerCase());
      }
      return results;
    })()).join("$$");
  };

  PresenterUtil.prototype.getEditableKey = function(is_editable) {
    if ((is_editable != null) && is_editable === true) {
      return 'EDITABLE';
    } else {
      return 'NOT_EDITABLE';
    }
  };

  PresenterUtil.prototype.getStatusKey = function(order) {
    var is_redeemed, status;
    if (order != null) {
      status = order.STATE;
      if (status === "EXPIRED") {
        is_redeemed = PresenterUtil.prototype.isRedeemed(order);
        if ((is_redeemed != null) && is_redeemed === true) {
          status = "EXPIRED_REDEEMED";
        } else {
          status = "EXPIRED_UNREDEEMED";
        }
      }
      return status;
    }
  };

  PresenterUtil.prototype.getFulfillmentMethodKey = function(order) {
    var fulfillmentKey, fulfillmentMethod, ref;
    fulfillmentKey = 'fulfilled_enabled';
    fulfillmentMethod = order != null ? (ref = order.deal) != null ? ref.fulfillmentMethod : void 0 : void 0;
    if ((fulfillmentMethod != null ? fulfillmentMethod.length : void 0) > 0) {
      fulfillmentMethod = fulfillmentMethod.toUpperCase();
      if ((new RegExp("DROP")).test(fulfillmentMethod)) {
        return "DROPSHIP";
      } else {
        return _.compact(fulfillmentMethod.split(" ")).join("_");
      }
    }
    return fulfillmentKey;
  };

  PresenterUtil.prototype.getShipmentStatusKey = function(order) {
    if (order != null ? order.shipmentDetails : void 0) {
      return order.shipmentDetails.SHIPMENT_STATE;
    }
  };

  PresenterUtil.prototype.getGiftStatusKey = function(order) {
    if (order.isGiftClaimed === true) {
      return "GIFT_CLAIMED";
    } else {
      return "GIFT_UNCLAIMED";
    }
  };

  PresenterUtil.prototype.getGiftDeliveryMethod = function(order) {
    if (order.giftInfo) {
      switch (order.giftInfo.giftDeliveryMethod) {
        case 'email':
          return 'EGIFT';
        default:
          return 'PRINTED_GIFT';
      }
    }
  };

  PresenterUtil.prototype.getGDTKeys = function(order) {
    var is_redeemed, keys;
    keys = ['GDT'];
    is_redeemed = PresenterUtil.prototype.isRedeemed(order);
    if ((is_redeemed != null) && is_redeemed === true) {
      keys.push('REDEEMED');
    } else {
      keys.push('UN_REDEEMED');
    }
    return keys;
  };

  PresenterUtil.prototype.getShipmentKey = function(order) {
    var voucher;
    if (order != null) {
      if (PresenterUtil.prototype.isShipmentAvailable(order)) {
        voucher = PresenterUtil.prototype.getFirstVoucher(order);
        if (voucher.shipments[0].carrier === "Processing") {
          return 'SHIPMENTS_PROCESSING';
        } else {
          return 'SHIPMENTS_AVAILABLE';
        }
      } else {
        return 'SHIPMENTS_NOT_AVAILABLE';
      }
    }
  };

  PresenterUtil.prototype.getReturnableKey = function(is_returnable) {
    if (!!is_returnable) {
      if (is_returnable === true) {
        return 'RETURNABLE';
      } else {
        return 'NOT_RETURNABLE';
      }
    } else {
      return 'NA';
    }
  };

  PresenterUtil.prototype.getNotReturnableReasonKey = function(is_timelimit_exceeded) {
    if ((is_timelimit_exceeded != null) && is_timelimit_exceeded === true) {
      return 'TIME_EXECEEDED';
    } else {
      return 'NON_RETURNABLE';
    }
  };

  PresenterUtil.prototype.getShippingAddressRequiredKey = function(order) {
    if ((order != null) && (order.deal != null) && order.deal.shippingAddressRequired) {
      return 'SHIPPING_ADDRESS_REQUIRED';
    } else {
      return 'SHIPPING_ADDRESS_NOT_REQUIRED';
    }
  };

  PresenterUtil.prototype.getGetawaysBookingStatus = function(order) {
    if (PresenterUtil.prototype.getStatusKey(order) === 'REFUNDED') {
      return 'REFUNDED';
    } else if (PresenterUtil.prototype.isBookingNonCancellable(order) && !PresenterUtil.prototype.isCheckInDatePassed(order)) {
      return 'NON_CANCELLABLE';
    } else if (PresenterUtil.prototype.isCheckInDatePassed(order)) {
      return 'EXPIRED';
    } else {
      return PresenterUtil.prototype.getStatusKey(order);
    }
  };

  PresenterUtil.prototype.isCheckInDatePassed = function(order) {
    var reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (((reservationSource != null ? reservationSource.checkInDate : void 0) != null) && Date.now() > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.checkInDate)) {
      return true;
    }
    return false;
  };

  PresenterUtil.prototype.isBookingNonCancellable = function(order) {
    var reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (((reservationSource != null ? reservationSource.cancellationDeadlineDate : void 0) != null) && Date.now > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.cancellationDeadlineDate)) {
      return true;
    }
    return false;
  };

  PresenterUtil.prototype.getReturnabilityLabelPrintingStatus = function(order) {
    var length, ref, ref1, ref2, returnStatus;
    length = (ref = order.goodsReturnInfo) != null ? (ref1 = ref.returns) != null ? ref1.length : void 0 : void 0;
    if (length > 0) {
      returnStatus = (ref2 = order.goodsReturnInfo) != null ? ref2.returns[length - 1].returnStatus : void 0;
      if (returnStatus === 'return_initiated' || returnStatus === 'warehouse_received' || returnStatus === 'auto_refunded' || returnStatus === 'closed') {
        return "return_initiated_label_not_printed";
      } else if (returnStatus === 'label_printed') {
        return "return_initiated_label_printed";
      } else {
        return 'NA';
      }
    } else {
      return 'NA';
    }
  };

  return PresenterUtil;

})();

module.exports = PresenterUtil;

//# sourceMappingURL=data:application/json;base64,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
